import { Typography } from "antd"

import Flex from "#blocks/Flex"

const AntdSection = ({
  title,
  children,
  style,
}: {
  title: string
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  return (
    <Flex col gap={8} style={{ paddingBottom: 16, ...style }}>
      <Typography.Title level={5}>{title}</Typography.Title>
      <Flex gap={20} style={{ alignItems: "center" }}>
        {children}
      </Flex>
    </Flex>
  )
}

export default AntdSection
